import { useEffect, useState } from "react";

import { cn } from "../../../../utils/classnames";

/**
 * Image wrapper that avoids showing the previously loaded image while a new
 * `src` is still downloading. Whenever `src` changes the component drops back
 * to a skeleton placeholder and only reveals the image once it has loaded.
 */
export const LazyImage = ({ src, alt, className, wrapperClassName, ...rest }) => {
  const [loaded, setLoaded] = useState(false);

  // Reset to the loading state every time the source changes so the old image
  // is hidden immediately instead of lingering until the new one arrives.
  useEffect(() => {
    setLoaded(false);
  }, [src]);

  return (
    <div className={cn("tw:relative", wrapperClassName)}>
      {!loaded && (
        <div className="tw:absolute tw:inset-0 tw:rounded-md tw:bg-[#F1F1F1] tw:animate-pulse" />
      )}
      <img
        src={src}
        alt={alt}
        onLoad={() => setLoaded(true)}
        className={cn(
          "tw:transition-opacity tw:duration-300",
          loaded ? "tw:opacity-100" : "tw:opacity-0",
          className
        )}
        {...rest}
      />
    </div>
  );
};
